import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) {
        $( '.half-pill-hero__half-pill, .half-pill-hero__image' ).addClass( 'js-animated' );
        return;
      }

      $( '.half-pill-hero' ).each( function( key, val ) {
        const halfPill = $( this ).find( '.half-pill-hero__half-pill' )[0];
        const image = $( this ).find( '.half-pill-hero__image' )[0];
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 80%',
            scrub: 0.15,
            onEnter: ( {progress, direction, isActive} ) => {
              $( halfPill ).addClass( 'js-animated' );
              $( image ).addClass( 'js-animated' );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( halfPill ).addClass( 'js-animated' );
                $( image ).addClass( 'js-animated' );
              }
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'half-pill-hero', COMPONENT );
} )( app );
